import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useNavigate, useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
const exportUserData = [
    { label: "CSV", value: "CSV" },
    { label: "PDF", value: "PDF" },
  ];

  const headers = [
    { label: "NAME", key: "name" },
    { label: "EMAIL", key: "email" },
    { label: "USER TYPE", key: "role_type" },
    { label: "ACCESS TO MODULES", key: "access_count" },
    { label: "CREATED DATE", key: "created_at" },
    { label: "LAST ACTIVITY", key: "last_activity" },
  ];

  const ExportUsers = (props) => {
    const [exportUserDetail, setexportUserDetail] = useState(
        exportUserData[1].value
      );
      const location = useLocation();
      const [parentRecords, setParentRecords] = useState(location.state?.userRecords);
      const [exportData, setExportData] = useState();
      const [userRecords, setUserRecords] = useState([]);
      const [fileName, setFileName] = useState(location.state?.fileName ? location.state?.fileName : "User_records");
      const [onBack, setonBackKey] = useState(location.state?.onBack ? location.state?.onBack : false)

      const history = useNavigate();
      useEffect(() => {
        fetchUserRecords();
      }, [parentRecords]);

      useEffect(()=> {
        if(userRecords?.length){
          if (!onBack) {
            if(exportUserData === "PDF"){
              history("/organization-setting/user-management/export-user/export-user-pdf", { 
              state: {
                        body: location?.state?.body,
                        pdfData: userRecords,
                        rootPage: location?.state?.rootPage,
                        fileNameForPDF: fileName,
                        exportUserDetail: exportUserDetail
                      },
              });
            }
            else{
              exportHandler();
            }
        }
      }
      },[userRecords]);

      const fetchUserRecords = async () => {
        if(!onBack){
          const formattedRecords = parentRecords?.map((user) => {     
            return {
              access_count: "Has access to "+ user.access_count + " modules",
              email: user.email,
              name: user.name,
              role_type: user.role_type,
              created_at: moment(user.created_at).format("DD-MM-YYYY"),
              last_activity: user.last_activity ? moment(user.last_activity).fromNow() : "New User",
            };
          });
          setUserRecords(formattedRecords);
          setexportUserDetail(location?.state?.exportUserDetail);
        } else{
          setUserRecords(parentRecords);
        }
      };

      const exportStatusChange = (e) => {
        setexportUserDetail(e.target.value);
      };

      const exportHandler = async() => {
        if(userRecords?.length){
          if(exportUserDetail === "CSV"){
            try{
              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet('User Records');
    
              worksheet.columns = headers.map((header)=>({
                header: header.label,
                key: header.key,
              }))
    
              const headRow = worksheet.getRow(1);
    
              headRow.eachCell((cell)=>{
                cell.fill = {
                  type: "pattern",
                  pattern: "solid",
                  fgColor: {
                    argb: "f3f4f6"
                  }
                }
                cell.font = {
                  bold: true,
                }
              })
    
              userRecords?.forEach((record)=>{
                const row = worksheet.addRow(record);
              })
    
              worksheet.columns.forEach((column)=>{
                let maxLength = 10;
                column.eachCell((cell)=>{
                  let value = cell?.value?.toString() || "";
                  maxLength = Math.max(maxLength,value?.length);
                })
                column.width = maxLength>50?50:maxLength+2;
              })
    
              const buffer = await workbook.xlsx.writeBuffer();
              saveAs(new Blob([buffer]),`${fileName}.xlsx`)
            }
            catch(e)
            {
              console.log(e);
            }
          } else {
              history("/organization-setting/user-management/export-user/export-user-pdf", {
                    state: {
                        body: location?.state?.body,
                        pdfData: userRecords,
                        rootPage: location?.state?.rootPage,
                        fileNameForPDF: fileName,
                        exportUserDetail: exportUserDetail
                      },
              });
          }
        } else{
          history(`${location?.state?.rootPage}/preparing-export-orders`, {
            state: {
              body: location?.state?.body,
              rootPage: location?.state?.rootPage,
              fileName: fileName,
              headers: headers,
              exportUserDetail: exportUserDetail
            },
          });
        }
      };
      return (
        <RightLayoutContainer>
          <PageTitleComp className="marginRightAdg">
          <PageHeader
          ghost={false}
          onBack={() => history("../user-management")}
          title="Export user records"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => history("../user-management")}
            >
              <Iconmoon icon="wrong" size={14} color="#EA655B" />
              Cancel
            </Button>,
          ]}
        ></PageHeader>
          </PageTitleComp>
          <DetailFields>
            <HaberForm>
              <div className="groupDetailWrap">
                <Form name="basic" autoComplete="off" className="haberLogin">
                  <Row gutter={[16, 16]} className="groupForm lastGroup">
                  <Col span={8}>
                  <GroupTitle>
                    <h2>Select Options</h2>
                    <p>
                      Here you can select options to customize data that will be
                      downloaded
                    </p>
                  </GroupTitle>
                  </Col>
                  <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Data Format</label>
                        <p>Select a format to download data</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div
                        className="boxFormType switchRadio"
                        style={{ justifyContent: "flex-end", display: "flex" }}
                      >
                        <Radio.Group
                          options={exportUserData}
                          onChange={exportStatusChange}
                          value={exportUserDetail? exportUserDetail : "PDF"}
                          optionType="button"
                          buttonStyle="solid"
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
                  </Row>
                  <div className="buttonRight" style={{ marginTop: "20px" }}>
                  <Form.Item>
                  { (!exportUserDetail || exportUserDetail === "PDF") ? (
                    <Button
                    onClick={() => exportHandler()}
                    className="themeBtn"
                  >
                    Preview &#38; Download User Records
                  </Button>
                ) : (
                  <Button className="themeBtn csv"
                          onClick={() => exportHandler()}>
                            Download User Records
                    </Button>
                )}
                  </Form.Item>
                  </div>
                </Form>
              </div>
            </HaberForm>
          </DetailFields>
        </RightLayoutContainer>
      );
  };
  export default ExportUsers;